<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Payment Transaction Status</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" sm="12" md="12" lg="12">
                    <v-icon color="error">*</v-icon>
                    From Date (Inclusive)::
                    <input class="mt-7 pt-0" id="datePickerId" type="date" v-model="fromdate" />
                    <v-icon color="error" class="ml-3">*</v-icon>
                    To Date (Exclusive)::
                    <input class="mt-7 ml-2 pt-0" id="datePickerId" type="date" v-model="todate" />

                    <!-- <v-btn @click="paytm" :disabled="fromdate == null || todate == null" :loading="log_loader">Paytm</v-btn> -->
                    <v-btn @click="paytm" :disabled="fromdate == null || todate == null" :loading="log_loader"
                        class="button mt-2 ml-5 pt-0">Proceed</v-btn>
                </v-col>
            </v-row>
            <span v-if="show">
                <span v-if="deatils_list == ''">
                    <center><strong>0 Success Payment Found !!!</strong></center>
                </span>
                <br />
                <v-data-table v-if="deatils_list!=''" :headers="headers" :items="bookList" dense
                    class="elevation-1 mytable" @current-items="getFiltered">
                    <template v-slot:top class="pb-5">
                        <v-row dense justify="center" align="center">
                            <tr class="t-row">
                                <div>
                                    <th>
                                        <v-row>
                                            <span v-for="header in headers" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                        rounded dense outlined color="#0F2027" :label="header.text"
                                                        multiple clearable :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"></v-autocomplete>
                                                </span>
                                            </span>
                                        </v-row>
                                    </th>
                                </div>
                            </tr>
                        </v-row>
                    </template>
                    <template v-slot:item.save="{ item }">
                        <v-btn small rounded @click="generateReceipt(item)" class="button" :loading="save_loader">
                            Generate Receipt
                        </v-btn>
                    </template>
                </v-data-table>
            </span>
        </v-card>
        <!-- <v-row align="center" justify="center">
            <v-btn @click="paytm" :loading="log_loader">Paytm</v-btn>
        </v-row> -->
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            // dates: [],
            log_loader: false,
            save_loader: false,
            snackbar_msg: "",
            // extraBreadcrumbItems: [


            // ],
            breadcrumbClass: "breadcrumb-style1",
            color: "",
            snackbar: false,
            academic_year_list: null,
            current_academic_year: null,
            payment_transaction_history_list: [],
            loader: false,
            status_loader: false,
            filterArr: [],
            filters: {
                p_purpose: [],
                p_type: [],
             },
            fromdate: null,
            todate: null,
            deatils_list: [],
            show:false,
            headers: [
                { text: "Learner", value: "p_learner" },
                { text: "Transaction Cration Date", value: "p_date" },
                { text: "Purpose", value: "p_purpose" },
                { text: "Payment Type", value: "p_type" },
                { text: "Amount", value: "p_amount" },
                { text: "Order Id", value: "p_order_id" },
                { text: "Merchant Id", value: "p_merchantid" },
                { text: "Payment Gateway", value: "paymentgateway" },
                { text: "Generate Receipt", value: "save" },
            ],
        }),
        // computed: {
        //     dateRangeText() {
        //         return this.dates.join(" ~ ");
        //     },
        // },
        computed: {
            bookList() {
                    return this.deatils_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
        methods: {
                    getFiltered(e) {
                        this.filterArr = e;
                        },
                    columnValueList(val) {
                            return this.deatils_list.map((d) => d[val]);
                        },
            async generateReceipt(item) {
               // console.log(item)
              //  this.deatils_list.splice(item, 1); 
              //  console.log("111"+this.deatils_list)
              //  return
                const data = {
                    receipt_data: item.p_id,
                };
                try {
                    this.save_loader = true;
                    const res = await axios.post("/PaymentGatewayPayTM/generateReceipt", data);
                    console.log("result", res.data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Receipt Generated...");
                       // this.paytm()
                       const index = this.deatils_list.indexOf(item); 
                       if (index > -1) {
                       // alert("in if") 
                            this.deatils_list.splice(index, 1); 
                       }
                    // this.fromdate = null
                    // this.todate = null
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.save_loader = false;
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                } finally {
                    this.save_loader = false;
                    // this.deatils_list = []
                    // this.fromdate = null
                    // this.todate = null
                    
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            async paytm() {
                // if (this.dates.length != 2) {
                //     alert("Please selects 2 dates");
                //     return;
                // }
                // if (this.dates[0] == this.dates[1]) {
                //     alert("Please selects 2 diffrent dates");
                //     return;
                // }
                const data = {
                    fromdate: this.fromdate,
                    todate: this.todate,
                };
                try {
                    this.log_loader = true;
                    const res = await axios.post("/PaymentGatewayPayTM/paytmstatusapi", data);
                    console.log("result", res.data);
                    if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.fsmg);
                    } else if (res.data.flag == "YES") {
                        this.deatils_list = res.data.deatils_list;
                        this.show = true
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.log_loader = false;
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                } finally {
                    this.log_loader = false;
                }
            },
        },
    };
</script>

<style scoped>
    input[type="date"] {
        width: 30%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
</style>
